import { useEffect } from 'react';

const SITE_NAME = 'UpdateCommit';
const BASE_URL = 'https://updatecommit.com';

interface PageMetaOptions {
  title: string;
  description?: string;
  /** Caminho canônico da página, ex: "/free-solutions" */
  path?: string;
}

const upsertMeta = (selector: string, createAttrs: Record<string, string>, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    Object.entries(createAttrs).forEach(([key, value]) => element!.setAttribute(key, value));
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const upsertCanonical = (href: string) => {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

/**
 * Define título, descrição e URL canônica da página.
 * Necessário porque o site é uma SPA: sem isso todas as rotas
 * compartilham o mesmo title/description do index.html.
 */
const usePageMeta = ({ title, description, path }: PageMetaOptions) => {
  useEffect(() => {
    const fullTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`;
    document.title = fullTitle;
    upsertMeta('meta[property="og:title"]', { property: 'og:title' }, fullTitle);

    if (description) {
      upsertMeta('meta[name="description"]', { name: 'description' }, description);
      upsertMeta('meta[property="og:description"]', { property: 'og:description' }, description);
    }

    if (path !== undefined) {
      const url = `${BASE_URL}${path}`;
      upsertCanonical(url);
      upsertMeta('meta[property="og:url"]', { property: 'og:url' }, url);
    }
  }, [title, description, path]);
};

export default usePageMeta;
